<template>

  <div class="flex-row gap-xl flex-stretch">

    <div id="email-sidebar" :class="{shrink: viewState !== ViewStateEnum.INBOX}">
      <div class="flex-row align-items-center justify-content-between gap-xs" style="height: 62px">
        <h1 class="m-0">E-mail</h1>
        <dd-rounded-button
            v-if="viewState !== ViewStateEnum.CREATE"
            @click="()=>setShowCreateModal(true)"
            style="margin-right: -8px"
        >
          <template #icon>
            <dd-icon icon="mdi mdi-plus" size="lg" style="margin-left: -3.5px"/>
          </template>
        </dd-rounded-button>
      </div>
      <div class="mt-md">

        <div
          v-for="(account, index) in accounts"
          :key="index"
        >
          <dd-button
              class="width-stretch justify-content-between"
              :type="account.id === selectedAccount.id ? 'primary' : 'link'"
              :class="account.id !== selectedAccount.id ? 'bg-color-white mb-md' : ''"
              @click="setSelectedAccount(account.id)"
          >
            <div class="account-name">
              {{ account.address }}
            </div>
            <div class="badge pull-right" style="margin-right: -10px">{{unprocessedEmailCounts[account.id]}}</div>
          </dd-button>
          <div
              v-if="loading && account.id === selectedAccount.id"
              class="border-radius-md container-v-xs mb-md"
              style="background-color: rgba(255, 255, 255, 0.9)"
          >
            <dd-loading-indicator noMessage size="lg"/>
          </div>
          <div
              v-if="!loading && account.id === selectedAccount.id"
              class="border-radius-md container-v-xs mb-md"
              style="background-color: rgba(255, 255, 255, 0.9)"
          >
            <div
                id="navbar-unprocessed"
                :class="[
                'account-state container-v-xs pr-sm width-stretch justify-content-end mb-xs',
                 accountState === AccountStateEnum.UNPROCESSED ? 'selected' : ''
              ]"
                @click="selectAccountState(AccountStateEnum.UNPROCESSED)"
            >
              <p class="p-0 m-0 color-primary">Onverwerkt</p>
            </div>
            <div
                id="navbar-processed"
                :class="[
                'account-state container-v-xs pr-sm width-stretch justify-content-end mb-xs',
                 accountState === AccountStateEnum.PROCESSED ? 'selected' : ''
              ]"
                @click="selectAccountState(AccountStateEnum.PROCESSED)"
            >
              <p class="p-0 m-0 color-primary">Verwerkt</p>
            </div>
            <div
                v-if="!account.isMailbox"
                id="navbar-outbox"
                :class="[
                'account-state container-v-xs pr-sm width-stretch justify-content-end',
                 accountState === AccountStateEnum.OUTBOX ? 'selected' : ''
              ]"
                @click="selectAccountState(AccountStateEnum.OUTBOX)"
            >
              <p class="p-0 m-0 color-primary">Verzonden</p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="email-content" class="flex-col gap-md">
      <slot></slot>
    </div>

    <SelectCustomerModalComponent
        :visible="showCreateModal"
        @cancel="setShowCreateModal(false)"
        @input="handleCustomerSelect"
    />

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import accountStateEnum from "../enums/AccountStateEnum";
import SelectCustomerModalComponent from "~/pages/components/modal/SelectCustomerModal.vue";
import ViewStateEnum from "../enums/ViewStateEnum";

export default {
  name: "SidebarComponent.vue",
  components:{
    SelectCustomerModalComponent
  },
  data() {
    return {
      showCreateModal: false
    }
  },
  methods: {
    ...mapActions('email', [
      'setSelectedAccount',
      'setAccountState',
      'showCreateEmail'
    ]),
    selectAccountState( value ){
      this.setAccountState(value);
    },
    setShowCreateModal(state){
      this.showCreateModal = state;
    },
    handleCustomerSelect(selectedCustomer){
      this.setShowCreateModal(false);
      this.showCreateEmail(selectedCustomer.id);
    }
  },
  computed: {
    ViewStateEnum() {
      return ViewStateEnum;
    },
    AccountStateEnum() {
      return accountStateEnum
    },
    ...mapGetters('email', [
      'accounts',
      'unprocessedEmailCounts',
      'selectedAccount',
      'viewState',
      'accountState',
      'loading',
    ]),
  },
  watch:{
    unprocessedEmailCounts(){
      let dashboardEmailTabBadge = document.querySelector('.badge.total-email-count');
      if (Object.keys(this.unprocessedEmailCounts).length > 0 && dashboardEmailTabBadge) {
        let totalCount = Object.values(this.unprocessedEmailCounts).reduce((acc, val) => acc + val, 0);
        dashboardEmailTabBadge.textContent = `${totalCount}`;
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
#email-sidebar{
  width: 270px;
  min-width: 270px;
  @media only screen and (max-width: $screen-lg-min) {
    width: 200px;
    min-width: 200px;

    &.shrink{
      overflow-x: hidden;
      width: 0 !important;
      min-width: 0 !important;

      & + #email-content{
        max-width: 100% !important;
        margin-left: -$spacing-xl;
      }
    }
  }
}
#email-content{
  flex: 1;
  max-width: calc(100% - 270px);
  @media only screen and (max-width: $screen-lg-min) {
    max-width: calc(100% - 200px);
  }
}
.account-name{
  flex: 1;
  margin-left: -10px;
  text-align: left;
  font-size: 15px;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.account-state{
  cursor: pointer;
  &>p{
    text-align: right;
  }
  &.selected{
    border-radius: 0;
    position: relative;
    cursor: default;
    &>p{
      font-weight: 500 !important;
    }
    &::after{
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 100%;
      border-radius: 0 4px 4px 0;
      background-color: $color-primary;
    }
  }
}
</style>